import React from 'react';
import { formatAmountInUnit, parseINR, scaleINR } from './overlap.constants';
import styles from './OverlapTooltipContent.module.scss';

interface Props {
    // that month's Total B2B Revenue (formatted ₹ string) and intra revenue in ₹ (raw number),
    // plus the intra share % shown on the badge. Net = Total − Intra.
    total?: string;
    intraAmount?: number;
    pct?: string;
    unitDivisor?: number;
}

function IntraTooltipContent({ total, intraAmount, pct, unitDivisor = 1 }: Props) {
    const intraPctNum = pct != null ? parseFloat(pct) : NaN;
    const netPct = !isNaN(intraPctNum) ? `${(100 - intraPctNum).toFixed(1)}%` : null;

    const totalNum = parseINR(total);
    const intraNum = Number(intraAmount) || 0;
    const netValue = total ? formatAmountInUnit(totalNum - intraNum, unitDivisor) : '-';

    return (
        <div className={styles.Container}>
            <p className={styles.Title}>Intra Company Transaction Detected</p>

            <div className={styles.Rows}>
                <div className={styles.Row}>
                    <div className={styles.Labels}>
                        <span className={styles.Label}>Total</span>
                        <span className={styles.Label}>Intra{!isNaN(intraPctNum) ? ` (${intraPctNum.toFixed(1)}%)` : ''}</span>
                    </div>
                    <div className={styles.Values}>
                        <span className={styles.ValueDefault}>{(scaleINR(total, unitDivisor) as string) || '-'}</span>
                        <span className={styles.ValueRed}>{formatAmountInUnit(intraNum, unitDivisor)}</span>
                    </div>
                </div>

                <div className={styles.Divider} />

                <div className={styles.Row}>
                    <span className={styles.Label}>Net{netPct != null ? ` (${netPct})` : ''}</span>
                    <span className={styles.ValueBold}>{netValue}</span>
                </div>
            </div>
        </div>
    );
}

export default IntraTooltipContent;
